;(function ($) {
    'use strict';

    // Vyhledáme hlavní kontejner filtru podle ceny
    const $filterByPrice = $('#filterByPrice');
    if (!$filterByPrice.length) return; // Pokud kontejner neexistuje, kód se neprovede

    // Najdeme jednotlivé prvky filtru
    const $fromBtn = $filterByPrice.find('#filterPriceFrom'); // Input pro minimální cenu
    const $toBtn = $filterByPrice.find('#filterPriceTo'); // Input pro maximální cenu
    const defaults = [$filterByPrice.data('start'), $filterByPrice.data('end')]; // Výchozí hodnoty slideru
    const slider = document.getElementById('filterByPriceRange'); // Slider DOM element
    const $histogramItems = $('.histogram__item'); // Histogram prvky (pokud jsou přítomné)
    const units = $filterByPrice.data('units'); // Jednotky (např. Kč)

    // Formátování hodnot pro zobrazení na slideru
    const format = {
        to: value => `${Math.round(value).toLocaleString('cs')} ${units}`, // Přidání jednotek a formátování čísla
        from: value => Math.round(value), // Převod z textu na číslo
    };

    // Pomocná funkce pro převod hodnot slideru na celé číslo
    const getIntegers = values => values.map(value =>
        parseInt(value.replace(units, '').replace(',', '').replace(/\s/g, ''), 10) // Odstranění jednotek, mezer a převedení na číslo
    );

    // Inicializace nebo resetování slideru
    function initSlider() {
        // Pokud je slider již inicializován, zničíme ho, aby se nezdvojovala konfigurace
        if (slider.noUiSlider) {
            slider.noUiSlider.destroy();
        }

        // Vytvoření nového slideru s konfigurací
        noUiSlider.create(slider, {
            start: defaults, // Počáteční hodnoty slideru
            step: $filterByPrice.data('step'), // Krok slideru
            connect: true, // Zobrazení spojení mezi body slideru
            tooltips: true, // Zobrazení hodnot přímo na slideru
            format: format, // Použití vlastního formátu pro hodnoty
            range: {
                min: $filterByPrice.data('start'), // Minimální hodnota
                max: $filterByPrice.data('end'), // Maximální hodnota
            },
        });

        // Událost "update" - aktualizace hodnot při posunu slideru
        slider.noUiSlider.on('update', (values) => {
            const integers = getIntegers(values); // Převedení hodnot na celá čísla
            $(document).trigger('updateHistogram.histogram', [integers, $histogramItems]); // Aktualizace histogramu

            // Aktualizace inputů (minimální a maximální ceny)
            updateInput($fromBtn, integers[0]);
            updateInput($toBtn, integers[1]);
        });

        // Událost "set" - provede se po dokončení posunu slideru
        slider.noUiSlider.on('set', (values) => {
            const integers = getIntegers(values); // Převedení hodnot na celá čísla
            updateLivewire(slider, integers, $fromBtn, $toBtn); // Aktualizace Livewire komponent
        });

        // Událost změny v inputu pro minimální cenu
        $fromBtn.on('change', function () {
            slider.noUiSlider.set([this.value, null]); // Nastavení nové minimální hodnoty na slideru
        });

        // Událost změny v inputu pro maximální cenu
        $toBtn.on('change', function () {
            slider.noUiSlider.set([null, this.value]); // Nastavení nové maximální hodnoty na slideru
        });
    }

    // Aktualizace hodnot v inputech a jejich zobrazení
    function updateInput($input, value) {
        $input.val(value); // Nastavení nové hodnoty do inputu
        $input
            .siblings('.select2') // Najdeme sousední Select2 element (pokud existuje)
            .find('.select2-selection__rendered')
            .text(`${value.toLocaleString('cs')} ${units}`); // Aktualizujeme zobrazenou hodnotu s formátováním
    }

    // Aktualizace hodnot v Livewire komponentech
    function updateLivewire(slider, values, $fromBtn, $toBtn) {
        if ($(slider).hasClass('slider--price')) {
            // Pokud je slider na stránce s filtrem
            const filterLivewire = eval($('#filterLivewire').data('livewire')); // Získáme Livewire komponentu
            filterLivewire.set('filterPriceFrom', values[0]); // Nastavíme minimální cenu
            filterLivewire.set('filterPriceTo', values[1]); // Nastavíme maximální cenu
        } else {
            // Pokud je slider na jiné stránce (např. homepage)
            eval($fromBtn.data('livewire')).set('filterPriceFrom', values[0]);
            eval($toBtn.data('livewire')).set('filterPriceTo', values[1]);
        }
    }

    // Re-inicializace slideru při navigaci Livewire
    document.addEventListener('livewire:navigated', initSlider);
})(jQuery);
